import Button from '../../../components/ui/Button';
import Card, { CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import { usePageTitle } from '../../../hooks/shared';

export default function Subscription() {
  usePageTitle('Subscription');
  return (
    <div className="bg-neutral-50 min-h-screen py-8">
      <div className="container-custom max-w-4xl">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-serif font-bold mb-2">
            Subscription Management
          </h1>
          <p className="text-neutral-600">Manage your subscription and premium features</p>
        </div>

        <Card patrioticShadow className="mb-6">
          <CardHeader>
            <CardTitle>Current Plan: Free</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-neutral-600 mb-4">
              You're currently on the Free plan. Upgrade to access premium features like physical
              mail voter guides, priority support, and more.
            </p>
            <Button variant="primary">Upgrade to Premium</Button>
          </CardContent>
        </Card>

        <Card patrioticShadow>
          <CardHeader>
            <CardTitle>Premium Features</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2 text-neutral-600">
              <li className="flex items-center gap-2">
                <svg className="w-5 h-5 text-success-500" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Physical mail voter guides and polling maps
              </li>
              <li className="flex items-center gap-2">
                <svg className="w-5 h-5 text-success-500" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Mail voter registration forms directly
              </li>
              <li className="flex items-center gap-2">
                <svg className="w-5 h-5 text-success-500" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Priority email support
              </li>
              <li className="flex items-center gap-2">
                <svg className="w-5 h-5 text-success-500" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Advanced election reminders
              </li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
